export default __webpack_public_path__ + "static/carter-3dcb8492429dcf5c6009dfc56176880b.jpg";